import { getColor } from 'helpers';
import { ColorsDark, ColorsLight, useTheme } from 'libs/ui/theme';

export const useColor = (colors: { dark: ColorsDark; light: ColorsLight }) => {
  const { theme } = useTheme();
  return getColor(theme, colors);
};
